// src/loaders/index.js
import { loadOBJ } from './objLoader'
import { loadPLY } from './plyLoader'
import { loadSTL } from './stlLoader'

const registry = {
  '.obj': loadOBJ,
  '.ply': loadPLY,
  '.stl': loadSTL,
}

/**
 * Load a 3D model from a path or uploaded file data
 * @param {string|Object} pathOrData - URL/path ending in .obj/.ply/.stl or object with { type, data }
 * @returns {Promise<THREE.Mesh>}
 */
export function loadModel(pathOrData) {
  // Handle uploaded file data (object) vs path (string)
  if (typeof pathOrData === 'object') {
    // New format: { type: 'stl'|'ply'|'obj', data: blobUrl|{ objUrl, mtlUrl, textureUrls } }
    if (pathOrData.type && pathOrData.data !== undefined) {
      if (pathOrData.type === 'stl') {
        return loadSTL(pathOrData.data)
      } else if (pathOrData.type === 'ply') {
        return loadPLY(pathOrData.data)
      } else if (pathOrData.type === 'obj') {
        return loadOBJ(pathOrData.data)
      }
      return Promise.reject(new Error(`Unknown file type: ${pathOrData.type}`))
    }

    // Legacy format for OBJ: { objUrl, mtlUrl, textureUrls }
    if (pathOrData.objUrl) {
      return loadOBJ(pathOrData)
    }

    return Promise.reject(new Error('Invalid file data format'))
  }

  // Original behavior for file paths
  const ext = pathOrData.slice(pathOrData.lastIndexOf('.')).toLowerCase()
  const loaderFn = registry[ext]
  if (!loaderFn) {
    return Promise.reject(new Error(`No loader for ${ext}`))
  }
  return loaderFn(pathOrData)
}